import { render, staticRenderFns } from "./ConfigAlertDatadog.vue?vue&type=template&id=268095a4&"
import script from "./ConfigAlertDatadog.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertDatadog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports